export type ImgSrcInfo = {
  // url is optional to support easy handling of optional images from source,
  // (ie caller can pass data that may or may not be populated)
  url?: string;
  size?: string;
};

/**
 * Builds srcset string for img elements
 *
 * @param imgSrcData An array of ImgSrcInfo objects
 * @returns A srcset string to be used by img element
 */
export const buildSrcSetString = (imgSrcData: ImgSrcInfo[]): string => {
  return imgSrcData
    .filter((d) => d.url)
    .map((d) => `${d.url}${d.size ? ` ${d.size}` : ""}`)
    .join(", ");
};
